module.exports = { "default": require("core-js/library/fn/number/is-nan"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/core-js/number/is-nan.js
 ** module id = 277
 ** module chunks = 0
 **/